import IQuestion from "@/interfaces/IQuestion";
import { defineStore } from "pinia";

interface State {
    testId: number;
    questions: IQuestion[];
    currentQuestionNumber: number;
    userAnswers: IQuestion[];
}

/* eslint-disable */
export const useTestStore = defineStore('userTest', {
    state: () => {
        if (localStorage.getItem("piniaState")) {
            // @ts-ignore
            if (JSON.parse(localStorage.getItem("piniaState")).userTest) {
                // @ts-ignore
                return { testId: JSON.parse(localStorage.getItem("piniaState")).userTest.testId, questions: JSON.parse(localStorage.getItem("piniaState")).userTest.questions, userAnswers: JSON.parse(localStorage.getItem("piniaState")).userTest.userAnswers, currentQuestionNumber: JSON.parse(localStorage.getItem("piniaState")).userTest.currentQuestionNumber };
            } else {
                return {
                    testId: null,
                    questions: [],
                    userAnswers: [],
                    currentQuestionNumber: 0
                }
            }
        } else {
            return {
                testId: null,
                questions: [],
                userAnswers: [],
                currentQuestionNumber: 0
            }
        }
    },
    getters: {
        currentQuestion(): IQuestion | null {
            if (this.questions.length > 0) {
                return this.questions[this.currentQuestionNumber]
            } else {
                return null
            }
        }
    },
    actions: {
        settestId(id: number) {
            this.testId = id
        },

        setQuestions(questions: IQuestion[]) {
            this.questions = questions
        },

        setCurrentQuestionNumber(questionNumber: number) {
            this.currentQuestionNumber = questionNumber
        },

        setUserAnswer(answer: IQuestion) {
            if (this.userAnswers.length > 0) {
                if (this.userAnswers.some((item: IQuestion) => item.questionId === answer.questionId)) {
                    this.userAnswers[this.userAnswers.findIndex((item: IQuestion) => item.questionId === answer.questionId)] = answer;
                } else {
                    this.userAnswers.push(answer);
                }
            } else {
                this.userAnswers.push(answer);
            }
        },

        $reset() {
            this.testId = null;
            this.questions.length = 0;
            this.userAnswers.length = 0;
            this.currentQuestionNumber = 0;
        }
    }
})
